<template>
  <!-- FAQ(자주하는 질문) -->
  <div>
    <!-- 상단 검색 부분 -->
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-alert-circle</v-icon>FAQ
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>

      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
            <div class="d-flex mb-n6">
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="작성일" @update="onDateChange" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <v-text-field
                v-model="cNowSearchkeyWord"
                @keyup.enter="GetFaqInfo()"
                @click:append="GetFaqInfo()"
                append-icon="search"
                label="검색어"
                placeholder="제목"
                class="hidden-md-and-down"
                hide-details
                dense
                persistent-placeholder
              ></v-text-field>
            </div>
            <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="작성일" @update="onDateChange" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="cNowSearchkeyWord"
              @keyup.enter="GetFaqInfo()"
              @click:append="GetFaqInfo()"
              append-icon="search"
              label="검색어"
              placeholder="제목"
              class="hidden-lg-and-up"
              hide-details
              dense
              persistent-placeholder
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- 하단 검색 부분 -->
    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :page="iPageNum"
        :items="Records"
        :headers="headers"
        :single-select="bSingleSelect"
        v-model="selected"
        @click:row="handleClick"
        :items-per-page="15"
        item-key="cFAQId"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cCreateDateTime="{ item }">
          {{item.cCreateDateTime.substring(0,10)}}
        </template>
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>

    <FAQDialog ref="FAQDialogRef" />
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import {mapState} from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";

import FAQDialog from "../components/FAQDialog.vue"

export default {
  components: {
    IronDate,
    FAQDialog,
  },
  data: () => ({
    iPageNum : 0,
    cNoMsg : "",
    ChangableHeight : "",
    cNowSearchkeyWord : "",
    bSingleSelect : true,
    sNowSelectDate : Util.sFormatDate(Util.sYearFirstDate()) + " ~ " +  Util.sFormatDate(Date()),
    sStartDate : Util.sFormatDate(Util.sYearFirstDate()),
    sEndDate : Util.sFormatDate(Date()),
    selected : [],
    Records : [],
    headers : [
      { text: '신청번호', align: 'center', value: 'sNum', width : "50px"},
      { text: '제목', value: 'cFAQNm', sortable : false},
      { text: '작성일', value: 'cCreateDateTime', sortable : false},
      { text: '조회수', value: 'iShowCount'},
    ],
  }),
  computed: {
    ...mapState(["CustomInfo"]),
  },
  created() {
  },
  mounted() {
    this.sStartDate = "";
    this.sEndDate = "";
    this.GetFaqInfo();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    onDateChange(daterange){
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " + this.sEndDate;
      this.GetFaqInfo();
    },
    
    // 초기화 하기
    Initialize(){
      this.cNowSearchkeyWord = "";
      this.sStartDate = "";
      this.sEndDate = "";
      this.sNowSelectDate = Util.sFormatDate(Util.sYearFirstDate()) + " ~ " + Util.sFormatDate(Date());
      this.GetFaqInfo();
    },

    // FAQ 검색하기
    GetFaqInfo(){
      this.cNoMsg = ""
      this.Records = [];
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        NowSearchKeyWord : this.cNowSearchkeyWord,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "GetFaqInfo", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              setTimeout(() => {
                this.cNoMsg = "조회결과가 없습니다."
              }, 300);
            }

            for (let i = 0; i < res.data.Result.length; i ++){
              res.data.Result[i].sNum = i + 1
            }

            this.Records = res.data.Result;
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg); //에러메세지 다이어로그 띄우기
          }
        })
        .catch(err =>{ 
          EventBus.$emit("onShowMsg",true, err);
        }) 
    },
    // 조회수 증가시키기
    SetFaqCount(){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        FAQId : this.selected[0].cFAQId,
      }
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "SetFaqCount", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onShowMsg", true,""+err);
        })
      ));
    },

    // 데이터 테이블 목록 두 번 클릭 시 실행 함수
    async handleClick(value) {
      this.selected = [value]
      if (this.selected.length > 0){
        let res = await this.SetFaqCount()
        if (res.data.ResultCd == "00") {
          this.selected[0].iShowCount =  res.data.Result[0].iShowCount
          this.$refs.FAQDialogRef.ShowDialog(this.selected[0])
        } else {
          EventBus.$emit("onShowMsg",true, res.data.Msg);
        }
      }
    },
  }
}
</script>